export var CoralogixEventType;
(function (CoralogixEventType) {
    CoralogixEventType["ERROR"] = "error";
    CoralogixEventType["NETWORK_REQUEST"] = "network-request";
    CoralogixEventType["LOG"] = "log";
    CoralogixEventType["USER_INTERACTION"] = "user-interaction";
    CoralogixEventType["WEB_VITALS"] = "web-vitals";
    CoralogixEventType["LONG_TASK"] = "longtask";
    CoralogixEventType["RESOURCES"] = "resources";
    CoralogixEventType["INTERNAL"] = "internal";
    CoralogixEventType["DOM"] = "dom";
})(CoralogixEventType || (CoralogixEventType = {}));
export var PerformanceTypes;
(function (PerformanceTypes) {
    PerformanceTypes["Resource"] = "resource";
    PerformanceTypes["LongTask"] = "longtask";
    PerformanceTypes["Navigation"] = "navigation";
})(PerformanceTypes || (PerformanceTypes = {}));
export var OtelNetworkAttrs;
(function (OtelNetworkAttrs) {
    OtelNetworkAttrs["METHOD"] = "http.method";
    OtelNetworkAttrs["URL"] = "http.url";
    OtelNetworkAttrs["STATUS_CODE"] = "http.status_code";
    OtelNetworkAttrs["HOST"] = "http.host";
    OtelNetworkAttrs["SCHEME"] = "http.scheme";
    OtelNetworkAttrs["STATUS_TEXT"] = "http.status_text";
    OtelNetworkAttrs["RESPONSE_CONTENT_LENGTH"] = "http.response_content_length";
})(OtelNetworkAttrs || (OtelNetworkAttrs = {}));
export var UrlType;
(function (UrlType) {
    UrlType["PAGE"] = "page";
    UrlType["NETWORK_REQUEST"] = "network_request";
})(UrlType || (UrlType = {}));
//# sourceMappingURL=types.js.map